import { useTranslation } from 'react-i18next';
import customTwMerge from 'utils/twMerge';

type Props = { className?: string };

export default function Copyright({ className }: Props) {
  const { t } = useTranslation('common');
  return (
    <p className={customTwMerge('text-center text-body16 text-neutral-400', className)}>
      © {new Date().getFullYear()} {t('vetamerikan-hospital')}
    </p>
  );
}
